import {
  COORDINATION_GROUP,
  TCoordinationGroup,
} from "../../../../../../../api/user/apiListStaffUsers";
import { TUserGroupAssignations } from "../../../../recruitersManager/types/UserGroupAssignations.types";
import { newStaffAssignationsContractStats } from "./StaffAssignationContractStats";
import { TStaffAssignationsCoordinator } from "./StaffAssignationsCoordinator";
import { newStaffAssignationServiceStats } from "./StaffAssignationServiceStats";

export const initGroups = (): TUserGroupAssignations[] => {
  const newGroups: TUserGroupAssignations[] = [];

  // Barcelona Ciudad → Barcelona Metro → Madrid Ciudad → Madrid Metro → ...
  newGroups.push({
    id: COORDINATION_GROUP.BCN,
    serviceStats: newStaffAssignationServiceStats(),
    contractStats: newStaffAssignationsContractStats(),
    users: [],
    unassignedContracts: [],
    maxContractsAssigned: 0,
    maxServicesAssigned: 0,
  });
  newGroups.push({
    id: COORDINATION_GROUP.NORTH_ZONE,
    serviceStats: newStaffAssignationServiceStats(),
    contractStats: newStaffAssignationsContractStats(),
    users: [],
    unassignedContracts: [],
    maxContractsAssigned: 0,
    maxServicesAssigned: 0,
  });
  newGroups.push({
    id: COORDINATION_GROUP.MAD,
    serviceStats: newStaffAssignationServiceStats(),
    contractStats: newStaffAssignationsContractStats(),
    users: [],
    unassignedContracts: [],
    maxContractsAssigned: 0,
    maxServicesAssigned: 0,
  });
  newGroups.push({
    id: COORDINATION_GROUP.SOUTH_ZONE,
    serviceStats: newStaffAssignationServiceStats(),
    contractStats: newStaffAssignationsContractStats(),
    users: [],
    unassignedContracts: [],
    maxContractsAssigned: 0,
    maxServicesAssigned: 0,
  });
  newGroups.push({
    id: COORDINATION_GROUP.OTH_FAST,
    serviceStats: newStaffAssignationServiceStats(),
    contractStats: newStaffAssignationsContractStats(),
    users: [],
    unassignedContracts: [],
    maxContractsAssigned: 0,
    maxServicesAssigned: 0,
  });
  newGroups.push({
    id: COORDINATION_GROUP.OTH_SLOW,
    serviceStats: newStaffAssignationServiceStats(),
    contractStats: newStaffAssignationsContractStats(),
    users: [],
    unassignedContracts: [],
    maxContractsAssigned: 0,
    maxServicesAssigned: 0,
  });
  newGroups.push({
    id: COORDINATION_GROUP.OTHER,
    serviceStats: newStaffAssignationServiceStats(),
    contractStats: newStaffAssignationsContractStats(),
    users: [],
    unassignedContracts: [],
    maxContractsAssigned: 0,
    maxServicesAssigned: 0,
  });

  return newGroups;
};

export const validGroupForCoordinator = (
  coordinator: TStaffAssignationsCoordinator
): TCoordinationGroup => {
  if (
    coordinator.coordinationGroups &&
    coordinator.coordinationGroups.includes(COORDINATION_GROUP.MAD)
  ) {
    return COORDINATION_GROUP.MAD;
  }
  if (
    coordinator.coordinationGroups &&
    coordinator.coordinationGroups.includes(COORDINATION_GROUP.BCN)
  ) {
    return COORDINATION_GROUP.BCN;
  }
  if (
    coordinator.coordinationGroups &&
    coordinator.coordinationGroups.includes(COORDINATION_GROUP.OTH_FAST)
  ) {
    return COORDINATION_GROUP.OTH_FAST;
  }
  if (
    coordinator.coordinationGroups &&
    coordinator.coordinationGroups.includes(COORDINATION_GROUP.OTH_SLOW)
  ) {
    return COORDINATION_GROUP.OTH_SLOW;
  }

  if (
    coordinator.coordinationGroups &&
    coordinator.coordinationGroups.includes(COORDINATION_GROUP.NORTH_ZONE)
  ) {
    return COORDINATION_GROUP.NORTH_ZONE;
  }

  if (
    coordinator.coordinationGroups &&
    coordinator.coordinationGroups.includes(COORDINATION_GROUP.SOUTH_ZONE)
  ) {
    return COORDINATION_GROUP.SOUTH_ZONE;
  }

  return COORDINATION_GROUP.OTHER;
};

export const groupName = (id: TCoordinationGroup): string => {
  // Barcelona Ciudad → Barcelona Metro → Madrid Ciudad → Madrid Metro → ...
  if (id === COORDINATION_GROUP.BCN) {
    return "Zona Barcelona Ciudad";
  }
  if (id === COORDINATION_GROUP.NORTH_ZONE) {
    return "Zona Metropolitana Barcelona";
  }
  if (id === COORDINATION_GROUP.MAD) {
    return "Zona Madrid Ciudad";
  }
  if (id === COORDINATION_GROUP.SOUTH_ZONE) {
    return "Zona Metropolitana Madrid";
  }
  if (id === COORDINATION_GROUP.OTH_FAST) {
    return "Zona Bilbao / Valencia / Zaragoza";
  }
  if (id === COORDINATION_GROUP.OTH_SLOW) {
    return "Resto de zonas";
  }
  if (id === COORDINATION_GROUP.ON_SHIFT) {
    return "De guardia";
  }
  return "Sin asignar";
};
